export default __webpack_public_path__ + "static/PPGoshaSans-Bold-b1f4f3c3748ed94872d18c5d9e5839e4.woff";